<template>
  <table-card :in-tab="true"
              :fields="fields"
              title="Tags awaiting scan"
    :items="list">
    <template v-slot:row-details="row">
      <div class="p-5">
        <b-form-textarea :rows="5" :value="row.item.html" />
        <div class="m-5 p-3 border-radius border">
          <iframe width="600" height="300" scrolling="no" frameborder="none" :srcdoc="row.item.html" />
        </div>
      </div>
    </template>
  </table-card>
</template>

<script>
  import auth from '@/auth'
  import {DemandApi} from "../../api"
  import TableCard from "../../../components/TableCard"

  export default {
      name: 'ScanQueue',
      created() {
        DemandApi.scanQueueList(this.companyId())
            .then(list => this.list = list)
            .catch((e) => this.$notify.error('Failed to list scans'))
      },
      data() {
          return {
              fields: [
                  { key: 'company' },
                  { key: 'company_id' },
                  { key: 'cid', label: 'Campaign Id' },
                  { key: 'crid', label: 'Creative Id' }
              ],
              list: []
          }
      },
      methods: {
        companyId() {
            return auth.isAdmin() ? null : auth.details().company_id
          }
      },
      components: {
          TableCard
      }
  }
</script>



// WEBPACK FOOTER //
// src/demand/pages/components/ScanQueue.vue